import { Condition, ConditionComparison, ValueSource } from '../../models/Condition';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { variableConditionByType, variableConditionHandoff, variableValueHandoff } from '../state/Outputs';
export class AgentHandoffService {
    getHandoffOutputIndex(conditionOutputs, outputName) {
        if (!conditionOutputs || conditionOutputs.length === 0) {
            return -1;
        }
        return conditionOutputs
            .findIndex(condition => this.isHandoffOutputConditionMet(condition, outputName));
    }
    createHandoffOutput(outputName, additionalProps) {
        const handoffOutput = new OutputViewModel();
        Object.assign(handoffOutput, additionalProps);
        handoffOutput.$isAgentOutput = true;
        handoffOutput.conditions = [
            new Condition({
                source: ValueSource.Context,
                variable: variableConditionHandoff,
                comparison: ConditionComparison.Equals,
                values: [variableValueHandoff],
            }),
            new Condition({
                source: ValueSource.Context,
                variable: variableConditionByType,
                comparison: ConditionComparison.Equals,
                values: [outputName],
            }),
        ];
        return handoffOutput;
    }
    isHandoffOutputConditionMet(output, outputName) {
        if (!output.$isAgentOutput || !output.conditions || output.conditions.length === 0) {
            return false;
        }
        let hasHandoffCondition = false;
        let hasForwardValue = false;
        for (const cond of output.conditions) {
            if (cond.source !== ValueSource.Context || cond.comparison !== ConditionComparison.Equals) {
                continue;
            }
            if (cond.variable === variableConditionHandoff &&
                cond.values?.includes(variableValueHandoff)) {
                hasHandoffCondition = true;
            }
            if (cond.variable === variableConditionByType &&
                cond.values?.includes(outputName)) {
                hasForwardValue = true;
            }
            if (hasHandoffCondition && hasForwardValue) {
                return true;
            }
        }
        return false;
    }
}
